// PsyPractice — hukuki belgeler / Dansk.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar — aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

const OWNER = 'PsyPractice (herefter »Platformen« eller »den Dataansvarlige«)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Brugsvilkår og ansvarsfraskrivelse",
    description:
      "Tjenestens karakter og grænser, hvad den ikke er en erstatning for, Brugerens forpligtelser og en omfattende ansvarsfraskrivelse, der lægger alt ansvar hos Brugeren.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Parter og accept",
        paras: [
          `Disse brugsvilkår indgås mellem ${OWNER} og enhver fysisk eller juridisk person, der tilgår eller bruger Platformen (»Brugeren«). Ved at oprette en konto, logge ind eller på nogen måde bruge Platformen bekræfter Brugeren at have læst og forstået disse vilkår og at acceptere og forpligte sig til dem i deres helhed og uden forbehold. Den, der ikke accepterer disse vilkår, må ikke bruge Platformen.`,
        ],
      },
      {
        heading: "2. Tjenestens karakter og grænser",
        bullets: [
          "PsyPractice er en AI-understøttet software til patientSIMULATION, der lader psykologistuderende og klinikere tidligt i karrieren gennemføre og registrere deres egen samtaleøvelse i sikre rammer.",
          "PsyPractice er ikke en uddannelses- eller undervisningsydelse; det er et softwareværktøj, der lader brugeren gennemføre og registrere sin egen øvelse. Platformen tilbyder hverken undervisning, læseplan, eksamener eller dokumenter og giver hverken titel, kvalifikation eller autorisation af nogen art.",
          "Den simulerede »patient« er ikke en rigtig klient; svarene er syntetiseret af kunstig intelligens, kan være fejlagtige, ufuldstændige, selvmodsigende eller vildledende og gør ikke krav på klinisk korrekthed eller sandhed.",
        ],
      },
      {
        heading: "2.1. Hvad Platformen ikke er en erstatning for",
        bullets: [
          "Den er IKKE rigtig terapi eller rådgivning, og den erstatter ingen session gennemført med en rigtig klient.",
          "Den er IKKE en erstatning for klinisk supervision. Feedbackrapporter fra supervisor-AI'en er automatisk genereret tekst; de er hverken en sagkyndig vurdering, en officiel bedømmelse eller en karakter.",
          "Den er IKKE et diagnostisk instrument, et screeningsredskab eller et vurderingsinstrument; intet output fra Platformen må bruges til diagnostiske eller kliniske beslutninger om et rigtigt menneske.",
          "Den MÅ IKKE bruges i kriser eller nødsituationer. Ved selvmordstanker, risiko for skade på sig selv eller andre eller enhver tilsvarende nødsituation skal du lukke Platformen og straks kontakte de lokale alarmtjenester eller en kompetent sundhedsinstitution.",
          "Den er IKKE en kilde til faglig kompetence, autorisation, titel eller beføjelse; tid brugt på Platformen og dens output må ikke fremlægges for nogen institution som dokumentation for kvalifikationer.",
        ],
      },
      {
        heading: "3. Brugerens erklæringer og forpligtelser",
        bullets: [
          "Brugeren forpligter sig til udelukkende at bruge Platformen inden for lovlige og etiske rammer og med det formål at udvikle sin egen faglige praksis.",
          "Brugeren accepterer IKKE at indtaste RIGTIGE patient-/klientdata, identificerende oplysninger eller helbredsoplysninger i særlige kategorier om nogen person; alle retlige følger heraf påhviler alene Brugeren.",
          "Brugeren forpligter sig til ikke at bruge noget output fra Platformen til diagnostik, behandling, intervention eller kliniske beslutninger vedrørende et rigtigt menneske.",
          "Brugeren er alene ansvarlig for sin egen faglige kompetence, sit beføjelsesområde og sin overholdelse af gældende faglige og etiske regler.",
          "Kontosikkerhed, fortrolighed om adgangskoden og al aktivitet, der udføres under Brugerens konto, er Brugerens ansvar.",
          "Kontoen er personlig; Brugeren forpligter sig til ikke at dele den med andre og ikke at bruge Platformen ved hjælp af automatiserede midler (bots, scripts osv.). Brugen af betalingsabonnementer er underlagt en grænse for rimelig brug (i øjeblikket 60 sessioner pr. kalendermåned), som er nærmere beskrevet i fjernsalgsaftalen.",
        ],
      },
      {
        heading: "4. Alt ansvar påhviler Brugeren (ansvarsfraskrivelse)",
        paras: [
          "Platformen leveres »SOM DEN ER« og »SOM TILGÆNGELIG«, uden nogen som helst udtrykkelig eller stiltiende garanti (herunder for uafbrudt drift, fejlfrihed, egnethed til et bestemt formål, nøjagtighed eller aktualitet).",
          "Brugeren accepterer og indestår for at være ENE og PERSONLIGT ansvarlig for ethvert direkte, indirekte, hændeligt, særligt eller afledt tab (herunder økonomisk tab, ikke-økonomisk skade, skade på fagligt omdømme, datatab, indtægtstab og skade forvoldt på tredjemand), der opstår som følge af Brugerens brug af eller manglende mulighed for at bruge Platformen, som følge af at forlade sig på AI-output eller som følge af på nogen måde at anvende sådanne output.",
          "I det videst mulige omfang, gældende ret tillader, GIVER Brugeren hermed uigenkaldeligt og betingelsesløst AFKALD på — nu og på forhånd — ethvert krav, enhver retssag og enhver ret til erstatning, som Brugeren måtte rejse mod Platformen, dens ejere, ansatte, udviklere, forretningspartnere og leverandører i anledning af enhver skade, Brugeren måtte blive udsat for, hvis et uheldigt udfald indtræffer.",
          "Brugeren forpligter sig endvidere til at holde Platformen fuldstændig skadesløs for ethvert krav, ethvert tab, enhver bøde og enhver omkostning (herunder advokatsalærer), hvis Platformen bliver kontaktet af tredjemand eller en institution som følge af Brugerens egen skyld, uagtsomhed eller brug i strid med disse vilkår.",
        ],
      },
      {
        heading: "5. Ansvarsbegrænsning",
        paras: [
          "Uden at det berører præceptive regler i gældende ret, er Platformens samlede retlige ansvar under alle omstændigheder begrænset til det beløb, Brugeren faktisk har betalt til Platformen i de 12 måneder, der går forud for den begivenhed, som ligger til grund for det pågældende krav. Er brugen gratis, er dette beløb nul.",
        ],
      },
      {
        heading: "6. Immaterielle rettigheder, ændring og ophør",
        bullets: [
          "Alle immaterielle rettigheder til Platformen, dens software, design, skabeloner til patientcases og indhold tilhører Platformen.",
          "Alle overdragelige økonomiske immaterielle rettigheder til indhold, som Brugeren skaber på Platformen (herunder de terapeutbeskeder, Brugeren skriver, sessionstransskripter og materiale afledt heraf), anses for overdraget til Platformen eksklusivt, tidsubegrænset og vederlagsfrit i det øjeblik, indholdet skabes; Platformen må bruge, gengive og behandle dette indhold globalt og uden begrænsning til ethvert formål, herunder drift af tjenesten, generering af feedback samt forbedring og udvikling af systemet (herunder forbedring ved hjælp af maskinlæring). Brugerens rettigheder til personoplysninger efter gældende databeskyttelsesret (GDPR/KVKK) berøres ikke af denne overdragelse og forbeholdes.",
          "Platformen forbeholder sig ret til når som helst og uden forudgående varsel at ændre, suspendere eller ophøre med disse vilkår og tjenestens omfang.",
          "Ved brud på disse vilkår kan Platformen suspendere eller lukke kontoen uden forudgående varsel.",
        ],
      },
      {
        heading: "7. Lovvalg og værneting",
        paras: [
          "Disse vilkår er underlagt Republikken Tyrkiets lovgivning. Republikken Tyrkiets domstole og fogedkontorer har kompetence i enhver tvist, der måtte opstå.",
          "For forbrugere med bopæl i Den Europæiske Union forbeholdes den beskyttelse, der følger af de præceptive forbrugerbeskyttelsesregler i bopælslandet og af databeskyttelsesrettighederne efter GDPR; dette lovvalg tilsidesætter ikke disse præceptive regler.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Privatlivspolitik",
    description:
      "GDPR som grundstandard; behandlede data, retsgrundlag, hosting i EU, internationale overførsler (AI-leverandøren) og bestemmelsen om overførsel til tredjelande efter KVKK art. 9 for brugere i Tyrkiet.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Denne privatlivspolitik forklarer, hvordan personoplysninger behandles på den Platform, der drives af ${OWNER}. Som databeskyttelsesretlig grundstandard følger politikken EU's generelle forordning om databeskyttelse (GDPR / 2016/679); for brugere i Tyrkiet gælder desuden den tyrkiske lov nr. 6698 om beskyttelse af personoplysninger (KVKK) — navnlig artikel 9 om overførsel til udlandet. KVKK-oplysningen og erklæringen om udtrykkeligt samtykke er integrerede dele af denne politik.`,
        ],
      },
      {
        heading: "Dataansvarlig og hostingsted",
        bullets: [
          "Dataansvarlig: PsyPractice. Henvendelser fra registrerede behandles gennem den kontaktkanal, der er oplyst på Platformen (kontakt-e-mail: info@psycora.com).",
          "Hosting: Platformen og dens database hostes inden for Den Europæiske Union — i et datacenter i Holland (Oracle Cloud). For brugere i EU/EØS behandles og opbevares data inden for EU.",
          "Hostingleverandøren optræder alene som databehandler i henhold til en indgået databehandleraftale (DPA).",
        ],
      },
      {
        heading: "Indsamlede data",
        bullets: [
          "Kontodata: navn, e-mail, hashet adgangskode, abonnements-/planoplysninger.",
          "Brugsdata: oprettede sessioner, sessionstransskripter, genererede patientcases, feedbackrapporter fra supervisor.",
          "Tekniske data: sessionslogfiler, IP, browser-/sprogpræference, logfiler for rate-limiting og sikkerhed.",
        ],
      },
      {
        heading: "Formål med behandlingen og retsgrundlag (GDPR art. 6)",
        bullets: [
          "Opfyldelse af en kontrakt (art. 6, stk. 1, litra b): oprettelse af konto, afvikling af sessioner, patienthukommelse på tværs af sessioner, supervisorens vurdering, administration af abonnement og forbrugsgrænser.",
          "Legitim interesse (art. 6, stk. 1, litra f): sikkerhed, forebyggelse af misbrug, systemforbedring og fejlsøgning.",
          "Retlig forpligtelse (art. 6, stk. 1, litra c): opbevaring/indberetning, der følger af lovgivningen.",
          "Samtykke (art. 6, stk. 1, litra a): analyse- og produktforbedringsbehandling, der ikke er strengt nødvendig for tjenesten, og, hvor det kræves, overførsel uden for EU/EØS.",
        ],
      },
      {
        heading: "Internationale overførsler",
        paras: [
          "Da hosting sker inden for EU (Holland), behandles EU-/EØS-brugeres data som udgangspunkt inden for EU uden overførsel til et tredjeland i det lag. For at generere AI-svar sendes sessionsindhold og prompts dog til AI-leverandøren (Anthropic), hvis behandlingsinfrastruktur kan være placeret uden for EU/EØS (f.eks. i USA).",
          "Sådanne overførsler uden for EU/EØS bygger på fornødne garantier efter GDPR art. 44 ff. — navnlig Europa-Kommissionens standardkontraktbestemmelser (SCC'er) — og der er indgået en databehandleraftale (DPA) med leverandøren. Platformen sælger IKKE personoplysninger til markedsføringsformål; data deles ikke med tredjeparter ud over det, der er strengt nødvendigt for at drive tjenesten (lovlige anmodninger fra kompetente myndigheder forbeholdes).",
        ],
      },
      {
        heading: "For brugere i Tyrkiet — KVKK art. 9 (overførsel til udlandet)",
        paras: [
          "Personoplysninger om brugere i Tyrkiet overføres ud af Tyrkiet, fordi hosting sker i Holland (EU), og de kan desuden overføres til Anthropic med henblik på AI-behandling. Disse overførsler er omfattet af KVKK art. 9 og bygger på fornødne garantier (den standardkontrakt/erklæring, som Rådet har offentliggjort) eller, hvor det kræves, på dit udtrykkelige samtykke. Overførslens omfang, modtagere og formål er beskrevet nærmere i KVKK-oplysningen og i erklæringen om udtrykkeligt samtykke.",
        ],
      },
      {
        heading: "Den registreredes rettigheder (GDPR art. 15–22)",
        bullets: [
          "Indsigt, berigtigelse, sletning (»retten til at blive glemt«) og begrænsning af behandling.",
          "Dataportabilitet: at modtage de oplysninger, du har afgivet, i et struktureret, almindeligt anvendt og maskinlæsbart format.",
          "Indsigelse: at gøre indsigelse mod behandling baseret på legitim interesse og mod direkte markedsføring.",
          "Rettigheder i forbindelse med afgørelser, der alene er baseret på automatisk behandling, herunder profilering.",
          "At trække samtykket tilbage til enhver tid ved samtykkebaseret behandling (tilbagetrækningen berører ikke lovligheden af den behandling, der er sket indtil da).",
          "Retten til at indgive klage til en tilsynsmyndighed: den relevante databeskyttelsesmyndighed i EU; databeskyttelsesmyndigheden (KVKK) i Tyrkiet.",
        ],
      },
      {
        heading: "Opbevaring og sikkerhed",
        bullets: [
          "Data opbevares, så længe formålet med behandlingen kræver det, og i de perioder, gældende ret foreskriver; når perioden udløber, slettes eller anonymiseres de.",
          "Følsomme felter (f.eks. adgangskode samt bekræftelses- og nulstillingskoder) opbevares krypteret/hashet; adgangen er rettighedsstyret.",
          "Da ingen form for overførsel eller lagring er 100 % sikker, kan absolut sikkerhed ikke garanteres.",
        ],
      },
      {
        heading: "Forbud mod rigtige patientdata",
        paras: [
          "Platformen er en simulationssoftware; det er forbudt at indtaste person- eller helbredsoplysninger om rigtige klienter. Alt ansvar, der opstår, fordi Brugeren indtaster data i strid med dette forbud, påhviler alene Brugeren.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "KVKK-oplysning",
    description:
      "Dataansvarlig, behandlingsformål, retsgrundlag, overførsel og den registreredes rettigheder efter artikel 10 i lov nr. 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Dataansvarlig",
        paras: [
          `I henhold til artikel 10 i den tyrkiske lov nr. 6698 om beskyttelse af personoplysninger (»KVKK«) behandles dine personoplysninger af ${OWNER} i egenskab af dataansvarlig inden for det omfang, der beskrives nedenfor.`,
        ],
      },
      {
        heading: "Behandlede data og formål",
        bullets: [
          "Identitet/kontakt (navn, e-mail): oprettelse af konto, autentifikation, kommunikation.",
          "Kundetransaktion (abonnement, plan, forbrug): levering af tjenesten, fakturering, håndhævelse af grænser.",
          "Transaktionssikkerhed (session, IP, logfiler): sikkerhed, forebyggelse af misbrug, retlig forpligtelse.",
          "Brugerindhold (sessionstransskripter, genererede cases): levering af softwaretjenesten og generering af feedback.",
          "Medlemskab af et institutionelt hold (holdets id, medlemsperiode): når brugeren kommer med på et hold, som en institution driver, vejlederens indsigt og administrationen af holdet.",
        ],
      },
      {
        heading: "Retsgrundlag (art. 5)",
        bullets: [
          "Indgåelse/opfyldelse af en kontrakt: data, der er nødvendige for at levere tjenesten.",
          "Den dataansvarliges legitime interesse: sikkerhed, forebyggelse af svig, systemforbedring.",
          "Retlig forpligtelse: opbevaring/indberetning, der følger af lovgivningen.",
          "Udtrykkeligt samtykke: overførsel til udlandet (art. 9) og yderligere behandling, der ikke er strengt nødvendig for tjenesten.",
        ],
      },
      {
        heading: "Overførsel til udlandet (art. 9)",
        paras: [
          "Fordi Platformen og dens database hostes inden for Den Europæiske Union — i et datacenter i Holland (Oracle Cloud) — overføres personoplysninger om brugere i Tyrkiet ud af Tyrkiet (til EU). For at generere AI-svar kan sessionsindhold og prompts desuden overføres til AI-leverandøren (Anthropic), hvis behandlingsinfrastruktur kan være placeret uden for EU/EØS (f.eks. i USA).",
          "Disse overførsler til udlandet er omfattet af KVKK art. 9 og bygger på fornødne garantier — såsom den standardkontrakt/erklæring, som Rådet har offentliggjort — eller, hvor det kræves, på dit udtrykkelige samtykke. Der er indgået databehandleraftaler (DPA'er) med hosting- og tjenesteleverandørerne.",
        ],
      },
      {
        heading: "Institutionelle hold og vejlederens indsigt",
        paras: [
          "Kommer du med på et hold, som et universitet, en klinik eller en tilsvarende institution har oprettet, kan holdets vejleder se dit sessionsindhold (transskripter) og dine supervisionsrapporter, så længe holdet løber. Denne indsigt omfatter kun dine sessioner, der er knyttet til holdet, og ophører, når dit medlemskab af holdet ophører.",
          "Adgangen opnås gennem et SÆRSKILT skærmbillede med udtrykkeligt samtykke, som vises, når du kommer med på holdet; den er ikke en del af Platformens generelle accept. Giver du ikke det samtykke, kan du ikke komme med på holdet, men du kan bruge Platformen individuelt præcis som før. Trækker du samtykket tilbage, ophører dit medlemskab af holdet, mens din individuelle brug er upåvirket.",
        ],
      },
      {
        heading: "Den registreredes rettigheder (art. 11)",
        bullets: [
          "At få at vide, om dine personoplysninger behandles, og i givet fald at anmode om oplysninger herom.",
          "At få at vide, hvad formålet med behandlingen er, og om oplysningerne bruges i overensstemmelse med formålet.",
          "At kende de tredjeparter, som oplysningerne overføres til i indlandet eller udlandet.",
          "At anmode om berigtigelse af ufuldstændig/urigtig behandling og, når betingelserne er opfyldt, om sletning/destruktion.",
          "At gøre indsigelse mod et resultat til ugunst for dig, der alene fremkommer ved automatiseret analyse.",
          "At kræve erstatning for skade lidt som følge af ulovlig behandling.",
        ],
      },
      {
        heading: "Henvendelser",
        paras: [
          "Du kan indgive anmodninger om dine rettigheder gennem den kontaktkanal, som den Dataansvarlige har oplyst. Henvendelser afsluttes inden for de frister, der er fastsat i KVKK og dens sekundære lovgivning.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Erklæring om udtrykkeligt samtykke",
    description:
      "Adskilt fra oplysningspligten; frivilligt samtykke til overførsel til udlandet og til AI-behandling.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Jeg erklærer, at jeg har læst og forstået KVKK-oplysningen, og at jeg frivilligt, informeret og udtrykkeligt samtykker til den behandling, der beskrives nedenfor. (I henhold til KVKK-Rådets afgørelse nr. 2018/90 indhentes udtrykkeligt samtykke adskilt fra oplysningspligten.)",
        ],
      },
      {
        heading: "Behandling, der samtykkes til",
        bullets: [
          "Overførsel af mine personoplysninger ud af Tyrkiet samt opbevaring og behandling af dem dér, fordi Platformen hostes i Den Europæiske Union (Holland / Oracle Cloud) (KVKK art. 9).",
          "Overførsel og behandling af mine sessionstransskripter og prompts hos AI-leverandøren (Anthropic), hvis behandlingsinfrastruktur kan være placeret uden for EU/EØS, med henblik på at generere AI-svar (KVKK art. 9).",
          "Behandling til produktforbedring og analyse, der ikke er strengt nødvendig for at levere tjenesten.",
          "Modtagelse af tjenesterelaterede meddelelser.",
        ],
      },
      {
        heading: "Tilbagetrækning af samtykke",
        paras: [
          "Jeg er indforstået med, at jeg til enhver tid kan trække mit udtrykkelige samtykke tilbage; da overførsel til udlandet til AI-leverandøren imidlertid er teknisk nødvendig for, at tjenesten kan fungere, accepterer jeg, at en tilbagetrækning af dette samtykke kan medføre, at jeg ikke kan bruge de pågældende funktioner eller tjenesten som helhed. Tilbagetrækningen berører ikke lovligheden af den behandling, der er foretaget frem til tilbagetrækningsdatoen.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice — see the comment there.
    id: "outreach",
    title: "Oplysning om erhvervsmæssig kontakt",
    description:
      "Til akademikere og institutionelle kontakter, der har modtaget en erhvervsmæssig kontakt-e-mail: hvor oplysningerne kommer fra, hvorfor de behandles, retsgrundlaget, og hvordan man frabeder sig henvendelser.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Denne oplysning henvender sig til modtagere af de erhvervsmæssige kontakt-e-mails, som PsyPractice sender til universiteternes psykologiske institutter og deres videnskabelige personale, i overensstemmelse med artikel 10 i den tyrkiske lov nr. 6698 om beskyttelse af personoplysninger (KVKK) og bekendtgørelsen om fremgangsmåden og principperne for opfyldelse af oplysningspligten. Da dine personoplysninger ikke er indhentet direkte hos dig, gives oplysningen senest ved den første kontakt, og derfor linker kontakt-e-mailen hertil.",
        ],
      },
      {
        heading: "1. Dataansvarlig",
        bullets: [
          `Navn: ${MERCHANT.legalNameEn} (enkeltmandsvirksomhed)`,
          `Adresse: ${MERCHANT.addressEn}`,
          `Skattekontor / -nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Behandlede data og deres kilde",
        paras: [
          "Behandlingen er begrænset til erhvervsmæssige kontaktoplysninger: navn, akademisk titel, universitet og institut, institutionel e-mailadresse og, hvor det er offentliggjort, institutionelt telefonnummer.",
          "Disse oplysninger er ikke indsamlet hos dig, men sammenstillet fra universiteternes offentligt tilgængelige officielle institut- og fakultetssider. Der behandles ingen særlige kategorier af oplysninger, og private (ikke-institutionelle) e-mailadresser bruges ikke til henvendelser.",
        ],
      },
      {
        heading: "3. Formål",
        paras: [
          "Dine oplysninger behandles for at præsentere et softwareværktøj bygget til psykologifaget, for at invitere dit institut til en mulig samtale om et pilotforsøg eller et samarbejde og for at føre den korrespondance, der knytter sig hertil. De bruges ikke til andre formål, sælges ikke og overføres ikke til tredjeparter med henblik på markedsføring.",
        ],
      },
      {
        heading: "4. Retsgrundlag",
        paras: [
          "Behandlingen bygger på den dataansvarliges legitime interesser efter KVKK artikel 5, stk. 2, litra f, forudsat at dette ikke krænker dine grundlæggende rettigheder og frihedsrettigheder: kontakten sker kun til en institutionel adresse, kun om et emne, der er direkte knyttet til modtagerens fagområde, og et begrænset antal gange.",
          "Alene den omstændighed, at oplysninger er offentligt tilgængelige online, udgør ikke i sig selv et retsgrundlag. Rådet for beskyttelse af personoplysninger har fastslået, at oplysningers offentlige karakter ikke gør dem anvendelige til ethvert formål, og at hensigten og formålet med offentliggørelsen skal vurderes særskilt; artikel 5, stk. 2, litra d, påberåbes derfor ikke.",
        ],
      },
      {
        heading: "5. Overførsler og opbevaring",
        paras: [
          "Korrespondancen føres via en e-mailleverandør, hvis infrastruktur kan være placeret i udlandet; sådanne overførsler sker med fornødne garantier efter KVKK artikel 9.",
          "Dine oplysninger slettes, når formålet med kontakten ophører, eller når du anmoder om det. Efter en anmodning om sletning bevares en strengt begrænset »kontakt mig ikke«-registrering udelukkende for at sikre, at du ikke bliver kontaktet igen; den bruges aldrig til henvendelser.",
        ],
      },
      {
        heading: "6. Kommercielle elektroniske henvendelser og retten til at frabede sig dem",
        paras: [
          "Reklamehenvendelser er omfattet af lov nr. 6563 om regulering af elektronisk handel. Du kan frabede dig dem uden at angive nogen grund; afmeldinger behandles inden for højst tre hverdage, hvorefter der ikke sendes flere reklamehenvendelser. Det er tilstrækkeligt at svare på den e-mail, du har modtaget, eller at skrive til " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Dine rettigheder",
        paras: [
          "Efter KVKK artikel 11 har du ret til at få at vide, om dine personoplysninger behandles, at anmode om oplysninger herom, at få at vide, hvad formålet med behandlingen er, og om oplysningerne bruges i overensstemmelse hermed, at kende de tredjeparter, som de overføres til i Tyrkiet eller i udlandet, at anmode om berigtigelse af ufuldstændige eller urigtige oplysninger, at anmode om sletning eller destruktion, at anmode om, at disse handlinger meddeles tredjeparter, at gøre indsigelse mod et resultat til ugunst for dig, der alene fremkommer ved automatiseret analyse, og at kræve erstatning for lidt skade.",
          `Anmodninger kan sendes til ${MERCHANT.email} og besvares inden for højst tredive dage. Du bevarer desuden retten til at indgive klage til Rådet for beskyttelse af personoplysninger.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Cookiepolitik",
    description: "De typer cookies, der bruges, deres formål og styring af præferencer.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Platformen bruger cookies og lignende teknologier til lokal lagring (localStorage) for at holde din session i live og huske dine præferencer.",
        ],
      },
      {
        heading: "Anvendte teknologier",
        bullets: [
          "Strengt nødvendige: session-/godkendelsestoken, sikkerhed. Tjenesten virker ikke uden disse.",
          "Funktionelle: sprogpræference (NEXT_LOCALE), præferencer for brugerfladen (f.eks. tema).",
          "Ydeevne/sikkerhed: tekniske logfiler til rate-limiting og opdagelse af misbrug.",
        ],
      },
      {
        heading: "Styring af præferencer",
        paras: [
          "Du kan slette eller blokere cookies i din browser; blokerer du de strengt nødvendige cookies, kan du dog hverken logge ind eller bruge kernefunktionerne. I tråd med principperne i GDPR/ePrivacy og KVKK's cookievejledning bruges ikke-nødvendige cookies alene på grundlag af din udtrykkelige præference eller dit samtykke.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Om os",
    description:
      "PsyPractices formål, den tjeneste vi tilbyder, og sælgerens kontaktoplysninger.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice er en AI-understøttet platform til patientsimulation og kliniske færdigheder, bygget til psykologistuderende og klinikere, der lige er trådt ind i faget. Brugerne gennemfører tekstbaserede terapisessioner; ved afslutningen af hver session vurderer en supervisor-AI samtalen og udarbejder en udviklingsorienteret feedbackrapport. Patient-AI'en bærer den terapeutiske relation videre session for session gennem hukommelse på tværs af sessioner.",
        ],
      },
      {
        heading: "Vores mission",
        paras: [
          "Vores mål er at give fremtidens fagfolk inden for mental sundhed et sikkert rum, hvor de kan øve samtalefærdigheder igen og igen uden nogen risiko for at skade rigtige klienter. PsyPractice er ikke en uddannelses- eller undervisningsydelse; det er et softwareværktøj, der lader brugeren gennemføre og registrere sin egen øvelse. Det er ikke rigtig terapi eller rådgivning, det er ikke en erstatning for klinisk supervision, det er ikke et diagnostisk eller vurderende instrument, og det må ikke bruges i kriser eller nødsituationer.",
        ],
      },
      {
        heading: "Det, vi tilbyder",
        bullets: [
          "Simulation af tekstbaserede terapisessioner på tværs af forskellige patientprofiler, syntetiseret ud fra klinisk litteratur.",
          "Automatiske vurderingsrapporter fra supervisor efter hver session.",
          "En model med en »levende patient« og hukommelse på tværs af sessioner, der udvikler den terapeutiske relation over tid.",
          "Generering af egne patienter, så studerende kan skabe deres egne AI-cases.",
          "Fremgangsmål, der følger udviklingen af mikrofærdigheder.",
        ],
      },
      {
        heading: "Sælger-/virksomhedsoplysninger",
        bullets: [
          `Firmanavn: ${MERCHANT.legalNameEn} (enkeltmandsvirksomhed)`,
          `Adresse: ${MERCHANT.addressEn}`,
          `Skattekontor / -nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Fjernsalgsaftale",
    description:
      "Vilkår om sælger, køber, tjeneste, pris, betaling, opfyldelse og fortrydelsesret efter den tyrkiske lov nr. 6502 og bekendtgørelsen om fjernsalgsaftaler.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Parter",
        bullets: [
          `SÆLGER: ${MERCHANT.legalNameEn} (enkeltmandsvirksomhed). Adresse: ${MERCHANT.addressEn}. Skattekontor/-nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-mail: ${MERCHANT.email}.`,
          "KØBER: den fysiske eller juridiske person, der opretter en konto på Platformen og køber et betalt abonnement (»Køberen«).",
        ],
      },
      {
        heading: "2. Aftalens genstand",
        paras: [
          "Genstanden for denne aftale er at fastlægge parternes rettigheder og forpligtelser i overensstemmelse med den tyrkiske lov nr. 6502 om forbrugerbeskyttelse og bekendtgørelsen om fjernsalgsaftaler for så vidt angår salget og opfyldelsen af det abonnement på en digital tjeneste, som Køberen har købt elektronisk via Platformen, og hvis egenskaber og salgspris er angivet nedenfor.",
        ],
      },
      {
        heading: "3. Tjenestens karakter og pris",
        bullets: [
          "Den solgte tjeneste er de AI-understøttede funktioner til patientsimulation, der tilbydes under en betalt abonnementsplan i softwaren PsyPractice (en digital tjeneste / en ret til at bruge softwaren).",
          "PsyPractice er ikke en uddannelses- eller undervisningsydelse; det er et softwareværktøj, der lader brugeren gennemføre og registrere sin egen øvelse. Abonnementsprisen er vederlag for adgang til denne software; det er ikke betaling for undervisning, læseplan, eksamener, konsulentydelser eller noget dokument.",
          "Abonnementets indhold, varighed (månedlig, en periode på 4 måneder eller årlig) og aktuelle pris vises tydeligt på Platformens pris-/betalingsside på købstidspunktet; det samlede beløb inklusive afgifter oplyses Køberen før betaling.",
          "Priserne gælder i den valuta, der vises på Platformen; medmindre abonnementet opsiges, fornys det automatisk til samme pris ved udgangen af den valgte løbetid.",
          "For abonnementer, der tilbydes som »ubegrænsede sessioner«, er brugen underlagt en grænse for rimelig brug (i øjeblikket 60 sessioner pr. kalendermåned). Når grænsen er nået, kan nye sessioner igen startes fra den første dag i den følgende kalendermåned; dette giver ikke ret til prisnedsættelse eller refusion. Grænsen skal forhindre kontodeling og automatiseret brug, og Sælgeren ændrer den ikke til skade for Køberen i en betalt abonnementsperiode.",
        ],
      },
      {
        heading: "4. Betaling",
        paras: [
          "Betalinger opkræves sikkert med kredit- eller betalingskort gennem den licenserede betalingsinstitution iyzico. Kortoplysninger gemmes ikke af Sælgeren; betalingen behandles gennem iyzicos sikre systemer. Ved tilbagevendende betalinger (abonnement) trækkes beløbet automatisk i hver fornyelsesperiode på det kort, Køberen har godkendt.",
        ],
      },
      {
        heading: "5. Opfyldelse og levering",
        paras: [
          "Tjenesten er digital, og der sker ingen fysisk levering. Når betalingen er bekræftet, gøres abonnementsfunktionerne straks tilgængelige på Køberens konto. Opfyldelsen sker elektronisk ved at give uafbrudt adgang i hele abonnementsperioden.",
        ],
      },
      {
        heading: "6. Fortrydelsesret og undtagelsen hertil",
        bullets: [
          "I henhold til artikel 15, stk. 1, litra ğ, i bekendtgørelsen om fjernsalgsaftaler kan fortrydelsesretten ikke udøves for immaterielle (digitale) varer og tjenester, der leveres øjeblikkeligt i elektronisk form, når opfyldelsen er påbegyndt med Køberens samtykke.",
          "Køberen anerkender på købstidspunktet, at tjenesten leveres straks, og at der derfor ikke består nogen fortrydelsesret. Køberen kan til enhver tid opsige abonnementet for at standse fornyelsen; opsigelsen får virkning ved udgangen af den igangværende betalte periode.",
          "De detaljerede refusionsvilkår fremgår af »Vilkår for levering og refusion«.",
        ],
      },
      {
        heading: "7. Tvister og ikrafttræden",
        paras: [
          "I tilfælde af en tvist kan Køberen henvende sig til forbrugervoldgiftsnævnet eller forbrugerdomstolene på sit bopælssted inden for de beløbsgrænser, som Handelsministeriet har offentliggjort. Denne aftale indgås og træder i kraft ved Køberens godkendelse i elektronisk form.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Vilkår for levering og refusion",
    description:
      "Levering af den digitale tjeneste, opsigelse af abonnement, undtagelsen fra fortrydelsesretten og betingelserne for refusion.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Levering (digital tjeneste)",
        bullets: [
          "PsyPractice er en fuldt digital tjeneste; der sker hverken fysisk forsendelse af varer eller levering med kurér.",
          "I det øjeblik betalingen bekræftes, aktiveres abonnementsfunktionerne automatisk og øjeblikkeligt på Køberens konto; der er ingen særskilt leveringstid og intet leveringsgebyr.",
          "Tjenesten tilgås via webbrowseren på enhver enhed med internetforbindelse.",
        ],
      },
      {
        heading: "Opsigelse af abonnement",
        bullets: [
          "Køberen kan til enhver tid opsige abonnementet i kontoindstillingerne. Opsigelsen får virkning ved udgangen af den igangværende betalte periode og standser den næste automatiske fornyelse.",
          "Efter opsigelsen fortsætter adgangen til tjenesten resten af den betalte periode.",
        ],
      },
      {
        heading: "Fortrydelsesret og refusion",
        bullets: [
          "Fordi tjenesten er en digital tjeneste, der leveres straks med Køberens samtykke, opstår der som udgangspunkt ingen fortrydelsesret — og dermed heller ingen ret til refusion — efter artikel 15, stk. 1, litra ğ, i bekendtgørelsen om fjernsalgsaftaler.",
          "Ved åbenbare mangler såsom en fejlagtig eller dobbelt opkrævning, fuldstændig manglende adgang til tjenesten af tekniske årsager eller lignende kan Køberen anmode om refusion ved at kontakte Sælgeren inden for rimelig tid fra betalingsdatoen.",
          `Anmodninger om refusion sendes til ${MERCHANT.email}; godkendte refusioner tilbageføres til det kort, der blev brugt til betalingen, gennem iyzicos infrastruktur, som regel inden for 14 dage. Refusionsperioden kan variere afhængigt af bankens behandlingstid.`,
        ],
      },
      {
        heading: "Kontakt",
        paras: [
          `Ved alle spørgsmål om levering, opsigelse og refusion: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
